import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import { Form, useFormikContext } from 'formik';
import React from 'react';
import { BlogCitingSection } from '../../components/citing/BlogCiting';
import { ContributorSection } from '../../components/ContributorSection';
import { RecommendationBar } from '../../components/Shared';
import GenericSection from '../../components/GenericSection';
import { useWritingForm } from '../../hooks/useWritingForm';
import { SourceType } from '../../types';
import { BLOG_FORM_TEST_ID, BLOG_FORM_PUB_INFO_SECTION_FIELD_LIST, BLOG_FORM_PUB_INFO_SECTION_NAME, BLOG_FORM_PUB_INFO_SECTION_TITLE, BLOG_FORM_PUB_INFO_TEST_ID, getBlogContributorsOptions } from './constants';
import { MoreOptionsSection } from '../../components/MoreOptions';

// Component to render Blog form when "create manual citation" button is clicked
var BlogForm = function BlogForm(_ref) {
  var _values$blog;
  _objectDestructuringEmpty(_ref);
  useWritingForm(SourceType.BLOG);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var postType = values === null || values === void 0 ? void 0 : (_values$blog = values.blog) === null || _values$blog === void 0 ? void 0 : _values$blog.posttype;
  return /*#__PURE__*/React.createElement(Form, {
    "data-test": BLOG_FORM_TEST_ID
  }, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(BlogCitingSection, null), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: getBlogContributorsOptions(postType)
  }), /*#__PURE__*/React.createElement(GenericSection, {
    fieldList: BLOG_FORM_PUB_INFO_SECTION_FIELD_LIST,
    name: BLOG_FORM_PUB_INFO_SECTION_NAME,
    sectionTitle: BLOG_FORM_PUB_INFO_SECTION_TITLE,
    "data-test": BLOG_FORM_PUB_INFO_TEST_ID,
    selectedTab: '' /** not tabs in this form */
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default BlogForm;